export const aboutPt = {
  embed: {
    cards: [
      { title: 'Nossa Missão', desc: 'Oferecer a melhor experiência na compra e venda de veículos, com transparência e confiança em cada negociação.' },
      { title: 'Confiança', desc: 'Nos destacamos pela honestidade e transparência em cada transação. Sua satisfação é a nossa prioridade.' },
      { title: 'Excelência', desc: 'Melhoria contínua dos nossos processos para garantir um atendimento de primeira linha a todos os nossos clientes.' },
    ],
    teamTitle: 'Nossa Equipe',
    teamSubtitle: 'Conheça as pessoas por trás da nossa concessionária',
    members: [
      { name: 'Nome do Gerente', role: 'Gerente Geral' },
      { name: 'Nome do Vendedor', role: 'Vendas' },
      { name: 'Nome do Consultor', role: 'Atendimento ao Cliente' },
    ],
  },
};
